import Close from '@mui/icons-material/Close'

interface MCloseProps {
  sx?: object
  fontSize?: string
}
const MClose = Close

export const CloseIcon: React.FC<MCloseProps> = ({ fontSize, sx, ...props }) => {
  return <MClose sx={sx} {...props} />
}
